import React, { Component } from 'react'
import DropDownStyles from '../../styles/components/dropdown'
import { Col } from 'react-flexbox-grid'
import MenuItem from '@material-ui/core/MenuItem'
import Benefit from './Benefit.js'
import BenefitDetails from './benefitsWidgets/BenefitDetails'
import Loading from '../../widgets/Loading'
import { connect } from 'react-redux'
import { fetchBenefits } from '../../redux/actions/benefitActions'
import { injectIntl } from 'react-intl'
import { push } from 'connected-react-router'
import BenefitHistory from './benefitsWidgets/BenefitHistory'
import { localize } from '../../util/Localizer'
import BackButton from '../../controls/BackButton'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'
import RBSearchBar from '../../controls/RBSearchBar'

import Select from '@material-ui/core/Select'

class BenefitSummary extends Component {
  constructor (props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
    this.getContent = this.getContent.bind(this)
    this.renderDropdown = this.renderDropdown.bind(this)
    this.state = {
      type: this.props.type,
      stickHeader: false
    }
  }

  componentDidMount () {
    this.props.fetchBenefits()
  }

  handleChange (event, index) {
    const value = index.props.value
    const dependents = this.props.dependents
    let selectedDep = dependents.filter((dependent, i) => {
      return dependent.depId === Number(value)
    })

    if (selectedDep.length > 0) {
      selectedDep = selectedDep[0]
    } else {
      this.props.push(`/Member/Benefits/${value}`)
    }

    if (this.props.type) {
      const formattedType = this.props.type.replace(/\s/g, '')
      this.props.push(`/Member/Benefits/${value}/${this.props.typeId}/${formattedType}`)
    } else {
      this.props.push(`/Member/Benefits/${value}`)
    }
  }

  getContent (currentDep, member) {
    if (!this.props.type) {
      return (<Benefit benefits={this.props.benefits} selectedMember={currentDep} />)
    } else if (this.props.isHistory === 'History') {
      return (<BenefitHistory selectedMember={currentDep} type={this.props.type} currentMember={member} />)
    } else {
      // TODO: this component should either be a generic component, or we need a switch(this.props.type) here
      return (<BenefitDetails dependentId={currentDep} typeId={this.props.typeId} type={this.props.type} />)
    }
  }

  renderDropdown (currentDep) {
    const { classes = {} } = this.props

    if (this.props.isHistory !== 'History' && !this.props.type) {
      return (
        <div className='dropdownContainer' id='dropdownContainer'>
          <div>
            <label>{localize('pages.benefitSummary.member')}</label>
            <br />
            <Select
              className={classes.baseDropdown}
              aria-label={localize('pages.ariaLabel.dropDown')}
              value={Number(currentDep)}
              onChange={this.handleChange}
              disabled={this.props.isFetching}
            >
              {
                this.props.members.map((member, indx) => {
                  return <MenuItem value={Number(member.Id)} key={indx}>{member.Name}</MenuItem>
                })
              }
            </Select>
          </div>

        </div>
      )
    } else {
      return (
        // render the beenfit details search
        <Paper className='dropdownContainer_Alt' id='dropdownContainer_Alt' square>
          <Col xs={12} lgOffset={1} lg={10}>
            <div className='searchBox'>
              <div>
                <label>{localize('pages.benefitSummary.member')}</label>
                <br />
                <Select
                  className={classes.baseDropdown}
                  aria-label={localize('pages.ariaLabel.dropDown')}
                  value={Number(currentDep)}
                  onChange={this.handleChange}
                  disabled={this.props.isFetching}
                >
                  {
                    this.props.members.map(function (member, indx) {
                      return <MenuItem value={Number(member.Id)} key={indx}>{member.Name}</MenuItem>
                    })
                  }
                </Select>
              </div>
              <RBSearchBar isDisabled={this.props.isFetching} />
            </div>
          </Col>
        </Paper>
      )
    }
  }

  render () {
    // create a default render element
    let renderElement = (
      <div className=''>
        <Loading message={localize('common.loadingContent')} />
      </div>
    )

    // get the element to render
    if (this.props.benefits) {
      let currentDep = '' + (this.props.dependentId ? this.props.dependentId : this.props.members[0].Id)
      renderElement = (
        <Col className='benefitSummary'>

          {this.props.type &&
            <div>
              <BackButton label={localize('pages.benefitHistory.backButton')} />
            </div>
          }
          {window.location.pathname.indexOf('History') > -1 ? null : this.renderDropdown(currentDep)}

          <div className='benefitBox'>
            {this.getContent(currentDep, this.props.members.find(member => member.Id === Number(currentDep)))}
          </div>
        </Col>
      )
    }

    // return the render elemnt
    return renderElement
  }
}

function mapStateToProps (state, ownProps) {
  const dependents = (state.memberSummaryReducer.memberSummary ? state.memberSummaryReducer.memberSummary.dependents : []).map((dependent) => {
    return { Name: `${dependent.firstName} ${dependent.lastName}`, Id: dependent.depId }
  })
  const primaryMemberName = `${state.memberSummaryReducer.memberSummary.firstName} ${state.memberSummaryReducer.memberSummary.lastName}`

  var members = []

  if (state.BenefitReducer.benefits) {
    members = state.BenefitReducer.benefits[0].memberBenefitCoverage.map((mbc) => {
      return {
        Name: mbc.memberName,
        Id: mbc.depId
      }
    })
  } else {
    members = members.filter((member) => {
      return member.Name === primaryMemberName
    })
  }

  return {
    benefits: state.BenefitReducer.benefits,
    members: members,
    type: ownProps.type,
    isHistory: ownProps.isHistory,
    isFetching: state.BenefitDetailsReducer.isFetching,
    dependents: dependents
  }
}

const ConnectedBenefitSummary = connect(mapStateToProps, { fetchBenefits, push })(injectIntl(BenefitSummary))

const styles = {
  ...DropDownStyles
}

export default withStyles(styles)(ConnectedBenefitSummary)



// WEBPACK FOOTER //
// ./src/widgets/Member/BenefitSummary.js